<template>
  <div class="shop-top-info-wrapper-h5">
    <div class="banner-pos">
      <div class="banner-config">
        <img v-if="isH5" v-lazy="shopHeader.shopImg" data-width="750" alt="" />
        <!-- 非营业展示 * 店铺营业状态 -->
        <ShopStatus
          :status="+shopInfo.cShopStatus"
          :next-time="shopInfo.nextBizTimeDesc"
        />
        <div class="back-btn" @click="goBack" v-if="!isStoreFont">
          <i class="icon-linetype_back_iOS"></i>
        </div>
      </div>
    </div>
    <div class="shop-info-box clearfix">
      <div class="name-logo-box" @click="moreInfoShow('info')">
        <div class="shop-name" v-text="shopHeader.shopName"></div>
        <div v-if="shopHeader.logo" class="logo-img">
          <img v-lazy="shopHeader.logo" data-height="176" />
        </div>
      </div>
      <!-- 星级 -->
      <Rating
        class="shop-rating"
        :info="shopHeader.rating"
        @click.native="moreInfoShow('info')"
      />
      <!-- 配送信息  -->
      <Service
        v-if="serviceList.length"
        class="shop-service"
        :serviceList="serviceList"
        :disabled="!doBusiness"
      />
      <!-- 提示信息 -->
      <RichText
        v-if="shopHeader?.fulfillmentTip?.content"
        :text="shopHeader?.fulfillmentTip?.content"
        is-argb
        class="shop-tip"
      />
      <!-- 优惠信息 -->
      <div v-if="showTag" class="shop-top-discount-wrapper">
        <ShopTopDiscount
          :disabled="!doBusiness"
          :tags="shopHeader.tags"
          :coupon-tags="shopHeader.couponTags"
          @click.native="moreInfoShow('coupon')"
        />
      </div>
      <!-- 虚拟券 -->
      <div
        class="virtual-coupon"
        v-if="!isLogin && isStoreFont && shopHeader?.virtualCouponTags?.length"
      >
        <VirtualCoupon :coupon-tags="shopHeader.virtualCouponTags" />
      </div>
    </div>
  </div>
</template>

<script>
import ShopStatus from './shopStatus.vue';
import Rating from './rating.vue';
import Service from './service.vue';
import ShopTopDiscount from '@/components/ShopTopDiscount/index.vue';
import VirtualCoupon from './virtualCoupon.vue';
import { mapState } from 'vuex';
import { getLocalStorage } from '@/utils/localStorage';
import RichText from '@/components/RichText/index.vue';

export default {
  name: 'ShopTopInfo',
  components: {
    ShopStatus,
    Rating,
    Service,
    ShopTopDiscount,
    VirtualCoupon,
    RichText,
  },
  props: {
    serviceList: {
      type: Array,
      default: () => [],
    },
    isStoreFont: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    shopInfo(nVal) {
      this.setInit(nVal);
    },
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      shopInfo: ({ store }) => store.shopInfo,
      shopHeader: ({ store }) => store.shopHeader,
      attentionInfo: ({ store }) => store.attentionInfo,
    }),
    isLogin() {
      return getLocalStorage('isLogin');
    },
    doBusiness() {
      return +this.shopInfo.cShopStatus === 1;
    },
    showTag() {
      let tag =
        this.shopHeader?.tags?.length || this.shopHeader?.couponTags?.length;
      if (this.isStoreFont) {
        return this.isLogin && tag;
      } else {
        return tag;
      }
    },
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.back();
    },
    setInit(val) {
      this.doBusiness = +val.cShopStatus === 1;
      let tips = val.actTips || [];
      if (this.isH5) {
        tips = tips.splice(0, 2);
      }
      this.actTips = tips;
    },
    serviceClick() {
      this.moreInfoShow();
    },
    moreInfoShow(type) {
      this.$emit('changeMoreInfoStatus', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-content {
  width: 100%;
  margin: 0 auto;
}
.clearfix {
  clear: both;
  &:after {
    content: ' ';
    display: block;
    height: 0;
    clear: both;
  }
}
.shop-top-info-wrapper-h5 {
  position: relative;
  width: 100vw;
}

.banner-pos {
  position: relative;
  padding-top: rem(375);
}
.banner-config {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: rem(375);
  overflow: hidden;
}
.banner-config img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-config .bg-shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0;
  opacity: 0.4;
  background-image: linear-gradient(
    180deg,
    #000000 26%,
    rgba(0, 0, 0, 0.17) 65%
  );
}
.back-btn {
  position: absolute;
  top: rem(32);
  left: rem(32);
  width: rem(48);
  height: rem(48);
  font-size: rem(48);
  color: #fff;
  cursor: pointer;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 50%);
}

.shop-info-box {
  padding: rem(34) rem(32) rem(46);
  background: #fff;
  .name-logo-box {
    display: flex;
    align-items: center;
    .shop-name {
      flex: 1;
      line-height: rem(56);
      font-family: DiDiSans-Pro-Bold;
      font-size: rem(48);
      color: #000000;
      letter-spacing: 0;
      @include ellipsis(2);
    }
    .logo-img {
      flex-shrink: 0;
      margin-left: rem(44);
      width: rem(88);
      height: rem(88);
      background: rgba(255, 255, 255, 0);
      border: 1px solid #ffffff;
      border-radius: rem(28);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: rem(28);
      }
    }
  }
  .shop-rating {
    margin-top: rem(12);
  }
  .shop-service {
    margin-top: rem(22);
  }
  .shop-tip {
    font-family: DiDiSans-Pro-Regular;
    font-size: rem(22);
    color: rgba(0, 0, 0, 0.4);
    margin-top: rem(4);
  }
  .shop-top-discount-wrapper {
    margin-top: rem(32);
    position: relative;
    left: rem(-32);
    width: 100vw;
  }
  .virtual-coupon {
    margin-top: rem(40);
    position: relative;
    left: rem(-32);
    width: 100vw;
  }
}
</style>
